import { z } from 'zod';

const envViteVariables = z.object({
  VITE_ENVIRONMENT: z.string().nullish(),
  VITE_SITE_NAME: z.string(),
  VITE_ROOT_DOMAIN: z.string(),
  VITE_API_ENDPOINT: z.string(),
  VITE_FLOW_URL: z.string().nullish(),
  VITE_WITH_GOOGLE_AUTH: z.string().nullish(),
  VITE_GOOGLE_ID_AUTH: z.string(),
  VITE_WITH_FACEBOOK_AUTH: z.string().nullish(),
  VITE_TERMS_URL: z.string(),
  VITE_REFERRAL_URL: z.string(),
  VITE_MEDIA_CONTENT_URL: z.string(),
  VITE_CABINET_MAIN_PAGE: z.string(),
  VITE_THEME_STORAGE: z.string().nullish(),
  VITE_GTM_ID: z.string().nullish(),
  VITE_RENDLEY_LICENSE_NAME: z.string().nullish(),
  VITE_RENDLEY_LICENSE_KEY: z.string().nullish(),
  VITE_CONTENT_ONLY_BUILD: z.string().nullish(),
});

envViteVariables.parse(import.meta.env);

declare global {
  interface ImportMetaEnv extends z.infer<typeof envViteVariables> {}
}

export const config = {
  ENVIRONMENT: import.meta.env.VITE_ENVIRONMENT || 'development',
  SITE_NAME: import.meta.env.VITE_SITE_NAME,
  ROOT_DOMAIN: import.meta.env.VITE_ROOT_DOMAIN,
  API_ENDPOINT: import.meta.env.VITE_API_ENDPOINT,
  FLOW_URL: import.meta.env.VITE_FLOW_URL,
  WITH_GOOGLE_AUTH: Boolean(import.meta.env.VITE_WITH_GOOGLE_AUTH),
  GOOGLE_ID_AUTH: import.meta.env.VITE_GOOGLE_ID_AUTH,
  WITH_FACEBOOK_AUTH: Boolean(import.meta.env.VITE_WITH_FACEBOOK_AUTH),
  TERMS_URL: import.meta.env.VITE_TERMS_URL,
  REFERRAL_URL: import.meta.env.VITE_REFERRAL_URL,
  MEDIA_CONTENT_URL: import.meta.env.VITE_MEDIA_CONTENT_URL,
  CABINET_MAIN_PAGE: import.meta.env.VITE_CABINET_MAIN_PAGE,
  THEME_STORAGE: Boolean(import.meta.env.VITE_THEME_STORAGE),
  GTM_ID: import.meta.env.VITE_GTM_ID,
  RENDLEY_LICENSE_NAME: import.meta.env.VITE_RENDLEY_LICENSE_NAME,
  RENDLEY_LICENSE_KEY: import.meta.env.VITE_RENDLEY_LICENSE_KEY,
  CONTENT_ONLY_BUILD: Boolean(import.meta.env.VITE_CONTENT_ONLY_BUILD),
} as const;
